import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import NossaAcademia from './pages/NossaAcademia';
import Modalidades from './pages/Modalidades';
import Unidades from './pages/Unidades';
import Contato from './pages/Contato';
import './App.css';

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nossa-academia" element={<NossaAcademia />} />
          <Route path="/modalidades" element={<Modalidades />} />
          <Route path="/unidades" element={<Unidades />} />
          <Route path="/contato" element={<Contato />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
